/* Back to the Office — native filter sidebar (sections/btto-shop.liquid).
   Live filtering via Shopify's Section Rendering API, mobile drawer,
   'show more' / option search, thumbnail swap and AJAX add to basket. */
(function () {
  if (window.bttoShopInit) return;
  window.bttoShopInit = true;

  var root = function () { return document.querySelector('[data-btto-shop]'); };
  var controller = null;
  var timer = null;
  var openState = {};

  function formParams() {
    var form = document.getElementById('BttoFacets');
    var p = new URLSearchParams();
    if (!form) return p;
    new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    var sort = document.querySelector('[data-btto-sort]');
    if (sort && sort.value) p.set('sort_by', sort.value);
    return p;
  }

  function rememberOpen() {
    document.querySelectorAll('[data-btto-facet]').forEach(function (d) {
      openState[d.getAttribute('data-btto-facet')] = d.open;
    });
  }
  function restoreOpen() {
    document.querySelectorAll('[data-btto-facet]').forEach(function (d) {
      var k = d.getAttribute('data-btto-facet');
      if (k in openState && !d.classList.contains('is-active')) d.open = openState[k];
    });
  }

  function load(qs, opts) {
    opts = opts || {};
    var r = root(); if (!r) return;
    var wasDrawer = r.classList.contains('drawer-open');
    rememberOpen();
    r.classList.add('is-loading');
    if (controller) controller.abort();
    controller = new AbortController();
    var url = location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(r.getAttribute('data-section-id'));
    fetch(url, { signal: controller.signal, credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-btto-shop]');
        if (!next) { location.search = qs; return; }
        var scrollY = window.scrollY;
        var drawerScroll = (r.querySelector('.btto-facets') || {}).scrollTop || 0;
        ['data-stream', 'data-in-count', 'data-out-count', 'data-per-page', 'data-sold-out-heading'].forEach(function (a) {
          if (next.hasAttribute(a)) r.setAttribute(a, next.getAttribute(a));
        });
        r.innerHTML = next.innerHTML;
        restoreOpen();
        if (r.getAttribute('data-stream') === 'true') renderStream(qs);
        if (wasDrawer) { r.classList.add('drawer-open'); var f = r.querySelector('.btto-facets'); if (f) f.scrollTop = drawerScroll; var s = r.querySelector('.btto-drawer__scrim'); if (s) s.hidden = false; }
        if (opts.push !== false) history.pushState({ btto: qs }, '', location.pathname + (qs ? '?' + qs : ''));
        if (opts.scrollTop) {
          var top = r.querySelector('.btto-shop__results').getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: top, behavior: 'smooth' });
        } else { window.scrollTo(0, scrollY); }
        document.dispatchEvent(new CustomEvent('btto:results-updated'));
      })
      .catch(function (e) { if (e.name !== 'AbortError') location.search = qs; })
      .finally(function () { var x = root(); if (x) x.classList.remove('is-loading'); });
  }

  function queue(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { var p = formParams(); p.delete('page'); load(p.toString()); }, delay);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.matches('[data-btto-find]')) return;
    if (t.closest('#BttoFacets') || t.matches('[data-btto-sort]')) queue(t.type === 'number' ? 600 : 250);
  });

  document.addEventListener('submit', function (e) {
    if (e.target.id === 'BttoFacets') { e.preventDefault(); queue(0); return; }
    var atc = e.target.closest && e.target.closest('[data-btto-atc]');
    if (atc) { e.preventDefault(); addToCart(atc); }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-btto-find]')) return;
    var q = t.value.trim().toLowerCase();
    var facet = t.closest('.btto-facet');
    facet.classList.toggle('is-finding', q !== '');
    facet.querySelectorAll('.btto-facet__item').forEach(function (li) {
      var txt = li.textContent.toLowerCase();
      li.hidden = q !== '' && txt.indexOf(q) === -1;
    });
  });

  function setDrawer(open) {
    var r = root(); if (!r) return;
    r.classList.toggle('drawer-open', open);
    document.documentElement.classList.toggle('btto-lock', open);
    var s = r.querySelector('.btto-drawer__scrim'); if (s) s.hidden = !open;
    var btn = r.querySelector('[data-btto-drawer-open]'); if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var c = r.querySelector('.btto-drawer__close'); if (c) c.focus(); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var link = t.closest('[data-btto-link]');
    if (link) { e.preventDefault(); load(new URL(link.href, location.href).searchParams.toString()); return; }
    var page = t.closest('.btto-pagination a, .btto-soldout-next');
    if (page) { e.preventDefault(); load(new URL(page.href, location.href).searchParams.toString(), { scrollTop: true }); return; }
    var more = t.closest('[data-btto-more]');
    if (more) {
      var f = more.closest('.btto-facet'); var on = f.classList.toggle('show-all');
      more.textContent = on ? more.getAttribute('data-less') : more.getAttribute('data-more'); return;
    }
    if (t.closest('[data-btto-drawer-open]')) { setDrawer(true); return; }
    if (t.closest('[data-btto-drawer-close]')) { setDrawer(false); return; }
    var thumb = t.closest('.btto-thumb[data-btto-full]');
    if (thumb) { e.preventDefault(); swapThumb(thumb); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var r = root(); if (r && r.classList.contains('drawer-open')) setDrawer(false); }
  });

  document.addEventListener('mouseover', function (e) {
    var thumb = e.target.closest && e.target.closest('.btto-thumb[data-btto-full]');
    if (thumb) swapThumb(thumb);
  });

  function swapThumb(btn) {
    var card = btn.closest('.btto-card'); if (!card) return;
    var main = card.querySelector('.spf-product-card__image-main'); if (!main) return;
    main.removeAttribute('srcset'); main.removeAttribute('sizes');
    main.src = btn.getAttribute('data-btto-full');
    card.querySelectorAll('.btto-thumb.is-active').forEach(function (x) { x.classList.remove('is-active'); });
    btn.classList.add('is-active');
  }

  /* ---------- sold-out last ----------
     Pages 1..inPages: in-stock products (filter.v.availability=1, exact).
     Page inPages+1: fully sold-out products, loaded 24 at a time from
     filter.v.availability=0 (skipping mixed-stock products already shown). */
  var streamCtl = null;
  function streamInfo(qs) {
    var r = root();
    var pp = Number(r.getAttribute('data-per-page')) || 24;
    var inPages = Math.ceil(Number(r.getAttribute('data-in-count')) / pp);
    var p = new URLSearchParams(qs);
    var v = Math.max(1, parseInt(p.get('page') || '1', 10) || 1);
    var total = inPages + 1;
    if (v > total) v = total;
    return { v: v, pp: pp, inPages: inPages, total: total, outCount: r.getAttribute('data-out-count') };
  }
  function pageHref(qs, n) {
    var p = new URLSearchParams(qs); p.delete('section_id');
    if (n > 1) p.set('page', n); else p.delete('page');
    var str = p.toString();
    return location.pathname + (str ? '?' + str : '');
  }
  function buildPagination(qs, info) {
    if (info.total < 2) return '';
    var v = info.v, parts = [], last = 0;
    for (var i = 1; i <= info.total; i++) {
      if (i === 1 || i === info.total || (i >= v - 2 && i <= v + 2)) {
        if (last && i - last > 1) parts.push('<span class="part deco">…</span>');
        var label = i === info.total ? 'Out of stock' : String(i);
        parts.push(i === v ? '<span class="part current">' + label + '</span>' : '<span class="part"><a href="' + pageHref(qs, i) + '">' + label + '</a></span>');
        last = i;
      }
    }
    return '<div class="btto-pagination"><div class="pagination row">' +
      '<div class="small-12 medium-4 columns prev">' + (v > 1 ? '<a class="text-light" href="' + pageHref(qs, v - 1) + '">Previous</a>' : '') + '</div>' +
      '<div class="small-12 medium-4 columns pages">' + parts.join('') + '</div>' +
      '<div class="small-12 medium-4 columns next">' + (v < info.total ? '<a class="text-light" href="' + pageHref(qs, v + 1) + '">Next</a>' : '') + '</div>' +
      '</div></div>';
  }
  function segmentUrl(qs, avail, page) {
    var r = root();
    var sp = new URLSearchParams(qs);
    sp.delete('page'); sp.delete('section_id');
    sp.set('filter.v.availability', avail);
    if (page > 1) sp.set('page', page);
    sp.set('section_id', r.getAttribute('data-section-id'));
    return location.pathname + '?' + sp.toString();
  }
  function fetchCards(url, signal) {
    return fetch(url, { signal: signal, credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('#BttoResults > .btto-col'));
      });
  }
  // Collect at least `want` fully sold-out cards starting at availability=0 page `k`.
  function collectSoldOut(qs, k, want, pp, signal) {
    var got = [], fetched = 0;
    function step() {
      return fetchCards(segmentUrl(qs, '0', k), signal).then(function (cards) {
        fetched++;
        cards.forEach(function (c) { if (c.querySelector('.btto-card.spf-soldout')) got.push(c.outerHTML); });
        var more = cards.length >= pp;
        k++;
        if (more && got.length < want && fetched < 6) return step();
        return { html: got.join(''), nextPage: more ? k : 0 };
      });
    }
    return step();
  }
  function moreButton(n) {
    return n ? '<button type="button" class="btto-btn btto-btn--ghost btto-soldout-more" data-btto-soldout-more="' + n + '">Show more out-of-stock products</button>' : '';
  }
  function renderStream(qs) {
    var r = root(); if (!r) return;
    var list = r.querySelector('#BttoResults'); if (!list) return;
    var info = streamInfo(qs);
    var inSeg = info.v <= info.inPages;
    if (streamCtl) streamCtl.abort();
    streamCtl = new AbortController();
    var signal = streamCtl.signal;
    var safety = setTimeout(function () { list.classList.remove('is-pending'); }, 6000);
    var job;
    if (inSeg) {
      job = fetchCards(segmentUrl(qs, '1', info.v), signal).then(function (cards) {
        if (!cards.length) throw new Error('empty');
        var out = cards.map(function (c) { return c.outerHTML; }).join('');
        if (info.v === info.inPages) {
          out += '<a class="btto-soldout-next" href="' + pageHref(qs, info.v + 1) + '">That\'s everything in stock. See ' + info.outCount + ' out-of-stock products <span aria-hidden="true">→</span></a>';
        }
        return out + buildPagination(qs, info);
      });
    } else {
      var heading = r.getAttribute('data-sold-out-heading') || 'Currently out of stock';
      job = collectSoldOut(qs, 1, info.pp, info.pp, signal).then(function (res) {
        return '<div class="btto-soldout-divider"><span>' + heading + ' (' + info.outCount + ')</span></div>' +
          '<div class="btto-soldout-list">' + res.html + '</div>' + moreButton(res.nextPage) + buildPagination(qs, info);
      });
    }
    job.then(function (html) { list.innerHTML = html; })
      .catch(function (e) { if (e.name === 'AbortError') return; /* keep the server-rendered list */ })
      .finally(function () { clearTimeout(safety); list.classList.remove('is-pending'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-btto-soldout-more]');
    if (!btn) return;
    var r = root(); var pp = Number(r.getAttribute('data-per-page')) || 24;
    btn.disabled = true; btn.textContent = 'Loading…';
    collectSoldOut(location.search.slice(1), Number(btn.getAttribute('data-btto-soldout-more')), pp, pp)
      .then(function (res) {
        r.querySelector('.btto-soldout-list').insertAdjacentHTML('beforeend', res.html);
        if (res.nextPage) { btn.disabled = false; btn.textContent = 'Show more out-of-stock products'; btn.setAttribute('data-btto-soldout-more', res.nextPage); }
        else btn.remove();
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Show more out-of-stock products'; });
  });
  function initStream() {
    var r = root();
    if (r && r.getAttribute('data-stream') === 'true') renderStream(location.search.slice(1));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStream); else initStream();

  window.addEventListener('popstate', function () { if (root()) load(location.search.slice(1), { push: false }); });

  function addToCart(form) {
    var btn = form.querySelector('button[type=submit]');
    var label = btn && btn.querySelector('span');
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding…'; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function () {
        if (label) label.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('btto:added-to-cart', { bubbles: true }));
        // Rebuy Smart Cart opens itself on /cart/add.js; otherwise fall back to the cart page.
        setTimeout(function () {
          var smart = window.Rebuy && window.Rebuy.SmartCart;
          if (smart && typeof smart.show === 'function') { smart.show(); }
          else if (!document.querySelector('#rebuy-smart-cart, .rebuy-cart')) { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
        }, 300);
        setTimeout(function () { if (btn) btn.disabled = false; if (label) label.textContent = original; }, 2000);
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        if (label) label.textContent = original;
        alert((err && (err.description || err.message)) || 'Sorry, this item could not be added to your basket.');
      });
  }
})();
